module.exports = __webpack_public_path__ + "img/stadium.58b7ec2d.svg";